/**
 * 拼多多开平风控请求头（大小写必须与平台要求完全一致）
 * @see https://open.pinduoduo.com/application/document/browse?idStr=263992F97736A864
 */
export var PDD_HEADER_PATI = 'X-PDD-Pati'
export var PDD_HEADER_PAGE_CODE = 'X-PDD-PageCode'

/** 由 pddPati 注册，避免 axios ↔ pddPati 循环依赖 */
var pddReadyWaiter = null

export function setPddReadyWaiter(fn) {
	pddReadyWaiter = typeof fn === 'function' ? fn : null
}

/**
 * 等待 pagecode/pati 初始化完成（未注册时立即 resolve）
 * @returns {Promise<{pati: string, pagecode: string}>}
 */
export function waitPddRiskReady() {
	if (!pddReadyWaiter) {
		return Promise.resolve({
			pati: (typeof window !== 'undefined' && window.pati) || '',
			pagecode: (typeof window !== 'undefined' && window.pagecode) || ''
		})
	}
	return Promise.resolve(pddReadyWaiter()).then(function(result) {
		return result || {
			pati: '',
			pagecode: ''
		}
	})
}

/** 获取 page_code 自身不能等待 bootstrap，否则死锁 */
export function isPddBootstrapUrl(url) {
	return String(url || '').indexOf('api/cloud_security/page_code') !== -1
}

function removeWrongCasePddHeaders(headers) {
	if (!headers) {
		return
	}
	var keys = Object.keys(headers)
	for (var i = 0; i < keys.length; i++) {
		var key = keys[i]
		var lower = String(key).toLowerCase()
		if (lower === 'x-pdd-pati' || lower === 'x-pdd-pagecode') {
			delete headers[key]
		}
	}
}

/**
 * 按严格大小写写入风控头；会先清掉错误大小写的同名头，避免 axios 规范化残留。
 */
export function applyPddRiskHeaders(headers, pati, pagecode) {
	if (!headers) {
		return headers
	}
	removeWrongCasePddHeaders(headers)

	var hasPati = pati != null && pati !== ''
	var hasPageCode = pagecode != null && pagecode !== ''

	// AxiosHeaders：用 set 写入，并尽量保留原始大小写
	if (typeof headers.set === 'function') {
		if (hasPati) {
			headers.set(PDD_HEADER_PATI, pati, true)
		}
		if (hasPageCode) {
			headers.set(PDD_HEADER_PAGE_CODE, pagecode, true)
		}
		return headers
	}

	if (hasPati) {
		headers[PDD_HEADER_PATI] = pati
	}
	if (hasPageCode) {
		headers[PDD_HEADER_PAGE_CODE] = pagecode
	}
	return headers
}

export function buildPddRiskHeaders(pati, pagecode) {
	var headers = {}
	applyPddRiskHeaders(headers, pati, pagecode)
	return headers
}



// WEBPACK FOOTER //
// ./src/libraries/utils/pddRiskHeaders.js